<template>
  <div class="shipcompany" v-if="shipNo">
    <a :href="'http://www.kuaidi100.com/chaxun?com=' + (this.companyMapping[shipCompany] || shipCompany) + '&nu=' + shipNo" target="_blank" v-if="shipCompany != 'shunfeng'">
        <i class="fa fa-truck"></i> {{shipNo}}
    </a>
    <a :href="'http://www.sf-express.com/cn/sc/dynamic_function/waybill/#search/bill-number/' + shipNo" target="_blank" v-else>
      <i class="fa fa-truck"></i> {{shipNo}}
    </a>

  </div>
</template>

<script>
export default {
  name: 'ship_company',
  data () {
    return {
      companyMapping: {
        youzheng: 'youzhengguonei',
        yuantong: 'yuantong',
        shunfeng: 'shunfeng',
        shentong: 'shentong',
        zhongtong: 'zhongtong'
      }
    }
  },
  props: ['shipCompany', 'shipNo']
}
</script>


<style lang="scss" scoped>
  .shipcompany{
    display: inline-block
  }
</style>